module.exports = __webpack_public_path__ + "img/营销伙伴05.3f7e04c4.png";